const LoadingSpinner = () => {
    return (
      <div className="flex justify-center items-center h-screen bg-[#0B0C0D]">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-primary"></div>
      </div>
    );
  };
  
  export default LoadingSpinner;
  